// The one-time Add-to-Home-Screen card (IMPLEMENTATION §2.6 A2HS note, §3 M11 iOS hint, §6.3): non-blocking
// (only the card takes input), dismissible. When it shows and which text is decided by platform/a2hs.ts.
export interface A2hsHintProps {
  text: string;
  button: string;
  onDismiss(): void;
}

export function A2hsHint({ text, button, onDismiss }: A2hsHintProps) {
  return (
    <div class="ov-hint" role="status" data-overlay="a2hs">
      <p class="ov-text">{text}</p>
      <button type="button" class="ov-btn" data-hit="a2hs-dismiss" onClick={onDismiss}>
        {button}
      </button>
    </div>
  );
}
